export const TokenListByAddress = {
  1329: {
    "0x0": {
      id: "sei_native_sei",
      attributes: {
        address: "0x0",
        name: "SEI",
        symbol: "SEI",
        decimals: 18,
        initialSupply: "",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x0.png",
      },
    },
    "0xe30fedd158a2e3b13e9badaeabafc5516e95e8c7": {
      id: "sei_0xe30fedd158a2e3b13e9badaeabafc5516e95e8c7",
      attributes: {
        address: "0xe30fedd158a2e3b13e9badaeabafc5516e95e8c7",
        name: "Wrapped Sei",
        symbol: "WSEI",
        decimals: 18,
        initialSupply: "10000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xe30fedd158a2e3b13e9badaeabafc5516e95e8c7.png",
      },
    },
    "0x5f0e07dfee5832faa00c63f2d33a0d79150e8598": {
      id: "sei_0x5f0e07dfee5832faa00c63f2d33a0d79150e8598",
      attributes: {
        address: "0x5f0e07dfee5832faa00c63f2d33a0d79150e8598",
        name: "SEIYAN",
        symbol: "SEIYAN",
        decimals: 6,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x5f0e07dfee5832faa00c63f2d33a0d79150e8598.png",
      },
    },
    "0x5cf6826140c1c56ff49c808a1a75407cd1df9423": {
      id: "sei_0x5cf6826140c1c56ff49c808a1a75407cd1df9423",
      attributes: {
        address: "0x5cf6826140c1c56ff49c808a1a75407cd1df9423",
        name: "iSEI",
        symbol: "iSEI",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x5cf6826140c1c56ff49c808a1a75407cd1df9423.png",
      },
    },
    "0x3894085ef7ff0f0aedf52e2a2704928d1ec074f1": {
      id: "sei_0x3894085ef7ff0f0aedf52e2a2704928d1ec074f1",
      attributes: {
        address: "0x3894085ef7ff0f0aedf52e2a2704928d1ec074f1",
        name: "USDC via Noble",
        symbol: "USDC.n",
        decimals: 6,
        initialSupply: "10000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x3894085ef7ff0f0aedf52e2a2704928d1ec074f1.png",
      },
    },
    "0xb75d0b03c06a926e488e2659df1a861f860bd3d1": {
      id: "sei_0xb75d0b03c06a926e488e2659df1a861f860bd3d1",
      attributes: {
        address: "0xb75d0b03c06a926e488e2659df1a861f860bd3d1",
        name: "IBC Bridged USDT",
        symbol: "Kava USDT",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xb75d0b03c06a926e488e2659df1a861f860bd3d1.png",
      },
    },
    "0x160345fc359604fc6e70e3c5facbde5f7a9342d8": {
      id: "sei_0x160345fc359604fc6e70e3c5facbde5f7a9342d8",
      attributes: {
        address: "0x160345fc359604fc6e70e3c5facbde5f7a9342d8",
        name: "Bridged Wrapped Ether (Stargate)",
        symbol: "WETH",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x160345fc359604fc6e70e3c5facbde5f7a9342d8.png",
      },
    },
    "0xc18b6a15fb0ceaf5eb18696eefcb5bc7b9107149": {
      id: "sei_0xc18b6a15fb0ceaf5eb18696eefcb5bc7b9107149",
      attributes: {
        address: "0xc18b6a15fb0ceaf5eb18696eefcb5bc7b9107149",
        name: "POPO",
        symbol: "POPO",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xc18b6a15fb0ceaf5eb18696eefcb5bc7b9107149.png",
      },
    },
    "0x95597eb8d227a7c4b4f5e807a815c5178ee6dbe1": {
      id: "sei_0x95597eb8d227a7c4b4f5e807a815c5178ee6dbe1",
      attributes: {
        address: "0x95597eb8d227a7c4b4f5e807a815c5178ee6dbe1",
        name: "MILLI",
        symbol: "MILLI",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x95597eb8d227a7c4b4f5e807a815c5178ee6dbe1.png",
      },
    },
    "0x64445f0aecc51e94ad52d8ac56b7190e764e561a": {
      id: "sei_0x64445f0aecc51e94ad52d8ac56b7190e764e561a",
      attributes: {
        address: "0x64445f0aecc51e94ad52d8ac56b7190e764e561a",
        name: "Frax Shares",
        symbol: "FXS",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x64445f0aecc51e94ad52d8ac56b7190e764e561a.png",
      },
    },
    "0x5c85726f71afb7e26d769fb559ce0168ce1f8f4e": {
      id: "sei_0x5c85726f71afb7e26d769fb559ce0168ce1f8f4e",
      attributes: {
        address: "0x5c85726f71afb7e26d769fb559ce0168ce1f8f4e",
        name: "SEI USAGI",
        symbol: "USA",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x5c85726f71aFB7e26d769fB559Ce0168CE1F8f4E.png",
      },
    },
    "0x9c367a272f8e318d10118c6367fd69def30e430e": {
      id: "sei_0x9c367a272f8e318d10118c6367fd69def30e430e",
      attributes: {
        address: "0x9c367a272f8e318d10118c6367fd69def30e430e",
        name: "Pepei",
        symbol: "PEPEI",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x9C367a272f8E318D10118C6367fD69DEf30e430E.png",
      },
    },
    "0xecf7f1efc9620a911339619c91c9fa0f71e0600e": {
      id: "sei_0xecf7f1efc9620a911339619c91c9fa0f71e0600e",
      attributes: {
        address: "0xecf7f1efc9620a911339619c91c9fa0f71e0600e",
        name: "SEIYUN",
        symbol: "SEIYUN",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xECf7f1EFC9620A911339619C91c9FA0f71e0600E.png",
      },
    },
    "0xd78be621436e69c81e4d0e9f29be14c5ec51e6ae": {
      id: "sei_0xd78be621436e69c81e4d0e9f29be14c5ec51e6ae",
      attributes: {
        address: "0xd78be621436e69c81e4d0e9f29be14c5ec51e6ae",
        name: "$gonad",
        symbol: "$GONAD",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xd78BE621436e69C81E4d0e9f29bE14C5EC51E6Ae.png",
      },
    },
    "0x9134d733aac991b96e899af657c717276a627e32": {
      id: "sei_0x9134d733aac991b96e899af657c717276a627e32",
      attributes: {
        address: "0x9134d733aac991b96e899af657c717276a627e32",
        name: "FUCK ROY LOPEZ",
        symbol: "$FROY",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x9134d733AaC991b96E899af657C717276A627E32.png",
      },
    },
    "0xb8d41db605a3258010d531429e85b13c7abde579": {
      id: "sei_0xb8d41db605a3258010d531429e85b13c7abde579",
      attributes: {
        address: "0xb8d41db605a3258010d531429e85b13c7abde579",
        name: "CHUCKCOIN",
        symbol: "CHUCK",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xb8D41DB605A3258010D531429E85b13C7abdE579.png",
      },
    },
    "0xc6bc81a0e287cc8103cc002147a9d76cae4cd6e5": {
      id: "sei_0xc6bc81a0e287cc8103cc002147a9d76cae4cd6e5",
      attributes: {
        address: "0xc6bc81a0e287cc8103cc002147a9d76cae4cd6e5",
        name: "SeiBallz",
        symbol: "BALLZ",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xC6BC81A0E287cC8103cC002147a9d76caE4cD6E5.png",
      },
    },
    "0xf5020dc8ec5e0ef8869ecc3044933356650b61cf": {
      id: "sei_0xf5020dc8ec5e0ef8869ecc3044933356650b61cf",
      attributes: {
        address: "0xf5020dc8ec5e0ef8869ecc3044933356650b61cf",
        name: "Jay jeo",
        symbol: "JAYJEO",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xf5020DC8eC5e0ef8869Ecc3044933356650b61Cf.png",
      },
    },
    "0x6291148ae49e0f0d847bb97c4e060e49d87638ba": {
      id: "sei_0x6291148ae49e0f0d847bb97c4e060e49d87638ba",
      attributes: {
        address: "0x6291148ae49e0f0d847bb97c4e060e49d87638ba",
        name: "INSPECTOR",
        symbol: "REX",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x6291148AE49e0f0d847bB97C4E060E49D87638bA.png",
      },
    },
    "0xe5085112160ff75ee89a540cdba570eafdaf7f57": {
      id: "sei_0xe5085112160ff75ee89a540cdba570eafdaf7f57",
      attributes: {
        address: "0xe5085112160ff75ee89a540cdba570eafdaf7f57",
        name: "stSEI",
        symbol: "STSEI",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xe5085112160ff75ee89a540cdba570eafdaf7f57.png",
      },
    },
    "0x80eede496655fb9047dd39d9f418d5483ed600df": {
      id: "sei_0x80eede496655fb9047dd39d9f418d5483ed600df",
      attributes: {
        address: "0x80eede496655fb9047dd39d9f418d5483ed600df",
        name: "Frax USD",
        symbol: "frxUSD",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x80Eede496655FB9047dd39d9f418d5483ED600df.png",
      },
    },
    "0x3ec3849c33291a9ef4c5db86de593eb4a37fde45": {
      id: "sei_0x3ec3849c33291a9ef4c5db86de593eb4a37fde45",
      attributes: {
        address: "0x3ec3849c33291a9ef4c5db86de593eb4a37fde45",
        name: "Staked Frax Ether",
        symbol: "sfrxETH",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x3Ec3849C33291a9eF4c5dB86De593EB4A37fDe45.png",
      },
    },
    "0x43edd7f3831b08fe70b7555ddd373c8bf65a9050": {
      id: "sei_0x43edd7f3831b08fe70b7555ddd373c8bf65a9050",
      attributes: {
        address: "0x43edd7f3831b08fe70b7555ddd373c8bf65a9050",
        name: "Frax Ether",
        symbol: "frxETH",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x43eDD7f3831b08FE70B7555ddD373C8bF65a9050.png",
      },
    },
    "0x9faaea2cdd810b21594e54309dc847842ae301ce": {
      id: "sei_0x9faaea2cdd810b21594e54309dc847842ae301ce",
      attributes: {
        address: "0x9faaea2cdd810b21594e54309dc847842ae301ce",
        name: "seiyanETH",
        symbol: "seiyanETH",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x9fAaEA2CDd810b21594E54309DC847842Ae301Ce.png",
      },
    },
    "0xa8a3a5013104e093245164ea56588dbe10a3eb48": {
      id: "sei_0xa8a3a5013104e093245164ea56588dbe10a3eb48",
      attributes: {
        address: "0xa8a3a5013104e093245164ea56588dbe10a3eb48",
        name: "ssETH",
        symbol: "ssETH",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xA8A3A5013104e093245164eA56588DBE10a3Eb48.png",
      },
    },
    "0xdd7d5e4ea2125d43c16eed8f1ffefffa2f4b4af6": {
      id: "sei_0xdd7d5e4ea2125d43c16eed8f1ffefffa2f4b4af6",
      attributes: {
        address: "0xdd7d5e4ea2125d43c16eed8f1ffefffa2f4b4af6",
        name: "Jelly Token",
        symbol: "JLY",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xDD7d5e4Ea2125d43C16eEd8f1FFeFffa2F4b4aF6.png",
      },
    },
    "0x51121bcae92e302f19d06c193c95e1f7b81a444b": {
      id: "sei_0x51121bcae92e302f19d06c193c95e1f7b81a444b",
      attributes: {
        address: "0x51121bcae92e302f19d06c193c95e1f7b81a444b",
        name: "YAKA",
        symbol: "YAKA",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x51121BCAE92E302f19D06C193C95E1f7b81a444b.png",
      },
    },
    "0x37a4dd9ced2b19cfe8fac251cd727b5787e45269": {
      id: "sei_0x37a4dd9ced2b19cfe8fac251cd727b5787e45269",
      attributes: {
        address: "0x37a4dd9ced2b19cfe8fac251cd727b5787e45269",
        name: "fastUSD",
        symbol: "fastUSD",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x37a4dD9CED2b19Cfe8FAC251cd727b5787E45269.png",
      },
    },
    "0x0dd9e6a6aeb91f1e3596f69d5443b6ca2e864896": {
      id: "sei_0x0dd9e6a6aeb91f1e3596f69d5443b6ca2e864896",
      attributes: {
        address: "0x0dd9e6a6aeb91f1e3596f69d5443b6ca2e864896",
        name: "SHENRN",
        symbol: "SHENRN",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x0DD9e6A6AEb91f1e3596F69d5443b6ca2e864896.png",
      },
    },
    "0xbd82f3bfe1df0c84faec88a22ebc34c9a86595dc": {
      id: "sei_0xbd82f3bfe1df0c84faec88a22ebc34c9a86595dc",
      attributes: {
        address: "0xbd82f3bfe1df0c84faec88a22ebc34c9a86595dc",
        name: "CHIPS",
        symbol: "CHIPS",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xBd82f3bfE1dF0c84faEC88a22EbC34C9A86595dc.png",
      },
    },
    "0xe85dc0cceca105755753fef452c091def5324138": {
      id: "sei_0xe85dc0cceca105755753fef452c091def5324138",
      attributes: {
        address: "0xe85dc0cceca105755753fef452c091def5324138",
        name: "SAKEINU",
        symbol: "SAKE",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xe85dC0CCECa105755753Fef452C091dEF5324138.png",
      },
    },
    "0x3ea30c06f4ba6f696d3ba4b660c39da96ed8f686": {
      id: "sei_0x3ea30c06f4ba6f696d3ba4b660c39da96ed8f686",
      attributes: {
        address: "0x3ea30c06f4ba6f696d3ba4b660c39da96ed8f686",
        name: "Seibacca",
        symbol: "SBC",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x3eA30C06F4BA6f696D3ba4b660C39DA96ed8f686.png",
      },
    },
    "0xd0d622de44a521404dc50e4abef08de82269dcbf": {
      id: "sei_0xd0d622de44a521404dc50e4abef08de82269dcbf",
      attributes: {
        address: "0xd0d622de44a521404dc50e4abef08de82269dcbf",
        name: "SEIFUN",
        symbol: "SFN",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xd0D622dE44A521404dc50e4ABef08dE82269Dcbf.png",
      },
    },
    "0x893cc8a006b88beef66c79bbb1c14b9c6c0ad7cc": {
      id: "sei_0x893cc8a006b88beef66c79bbb1c14b9c6c0ad7cc",
      attributes: {
        address: "0x893cc8a006b88beef66c79bbb1c14b9c6c0ad7cc",
        name: "UMI",
        symbol: "UMI",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x893CC8a006b88BeeF66c79bBb1C14b9c6c0AD7Cc.png",
      },
    },
    "0x962aae191622498bca205c1c1b73e59ac7d295f2": {
      id: "sei_0x962aae191622498bca205c1c1b73e59ac7d295f2",
      attributes: {
        address: "0x962aae191622498bca205c1c1b73e59ac7d295f2",
        name: "WILSON",
        symbol: "WILSON",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x962Aae191622498BcA205c1c1B73E59aC7d295f2.png",
      },
    },
    "0x3a0a7a3ca25c17d15e8d51332fb25bfea274d107": {
      id: "sei_0x3a0a7a3ca25c17d15e8d51332fb25bfea274d107",
      attributes: {
        address: "0x3a0a7a3ca25c17d15e8d51332fb25bfea274d107",
        name: "SEIPEX CREDITS",
        symbol: "SPEX",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x3A0A7a3cA25C17D15E8d51332fb25BFEA274d107.png",
      },
    },
    "0x67da7010c6c231ad620e3940e707adb6c1a08f23": {
      id: "sei_0x67da7010c6c231ad620e3940e707adb6c1a08f23",
      attributes: {
        address: "0x67da7010c6c231ad620e3940e707adb6c1a08f23",
        name: "SeiWhale",
        symbol: "SEIWHALE",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x67DA7010C6c231AD620E3940e707adB6c1a08f23.png",
      },
    },
    "0xf20903d034b12a7266055fe97cebdb9199ec6925": {
      id: "sei_0xf20903d034b12a7266055fe97cebdb9199ec6925",
      attributes: {
        address: "0xf20903d034b12a7266055fe97cebdb9199ec6925",
        name: "BOOBLE",
        symbol: "BOOBLE",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xF20903d034B12a7266055FE97cEBdB9199Ec6925.png",
      },
    },
    "0x51c8f5d0305ac6880b775eedd217e400485c6a19": {
      id: "sei_0x51c8f5d0305ac6880b775eedd217e400485c6a19",
      attributes: {
        address: "0x51c8f5d0305ac6880b775eedd217e400485c6a19",
        name: "NAPCAT",
        symbol: "NAPCAT",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x51c8F5D0305Ac6880B775eEDD217E400485c6A19.png",
      },
    },
    "0x490736a46aaba689db5265510b5c53af4c23ded4": {
      id: "sei_0x490736a46aaba689db5265510b5c53af4c23ded4",
      attributes: {
        address: "0x490736a46aaba689db5265510b5c53af4c23ded4",
        name: "Happy Ape",
        symbol: "HAPE",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x490736a46aaBa689Db5265510B5C53aF4c23DEd4.png",
      },
    },
    "0xc972106ca2560fa0065e1ca01c9dc6d6e80cc7a1": {
      id: "sei_0xc972106ca2560fa0065e1ca01c9dc6d6e80cc7a1",
      attributes: {
        address: "0xc972106ca2560fa0065e1ca01c9dc6d6e80cc7a1",
        name: "SLOW",
        symbol: "SLOW",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xc972106cA2560fA0065e1CA01C9dC6D6e80cC7a1.png",
      },
    },
    "0x8c5529ad032c48bc6413df8e8dc83d26dc680079": {
      id: "sei_0x8c5529ad032c48bc6413df8e8dc83d26dc680079",
      attributes: {
        address: "0x8c5529ad032c48bc6413df8e8dc83d26dc680079",
        name: "Sei Less",
        symbol: "LESS",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x8c5529ad032c48bc6413Df8e8dC83D26Dc680079.png",
      },
    },
    "0xd0c7edf2109be009364ac3db76c6fe8a75728657": {
      id: "sei_0xd0c7edf2109be009364ac3db76c6fe8a75728657",
      attributes: {
        address: "0xd0c7edf2109be009364ac3db76c6fe8a75728657",
        name: "LORD SHISHO",
        symbol: "SHISHO",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xd0C7EdF2109bE009364ac3DB76C6fE8a75728657.png",
      },
    },
    "0x74547390fe40d5cea666008d44febe1340e7a3b0": {
      id: "sei_0x74547390fe40d5cea666008d44febe1340e7a3b0",
      attributes: {
        address: "0x74547390fe40d5cea666008d44febe1340e7a3b0",
        name: "Oolong",
        symbol: "OOLONG",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x74547390fe40D5cEA666008D44feBe1340E7a3B0.png",
      },
    },
    "0x69e48ce9cf965acc1de2ad5ad2fdbc3bdb51509b": {
      id: "sei_0x69e48ce9cf965acc1de2ad5ad2fdbc3bdb51509b",
      attributes: {
        address: "0x69e48ce9cf965acc1de2ad5ad2fdbc3bdb51509b",
        name: "COOK",
        symbol: "COOK",
        decimals: 6,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x69e48cE9CF965aCc1DE2aD5ad2FdbC3Bdb51509b.png",
      },
    },
    "0xf9bdbf259ece5ae17e29bf92eb7abd7b8b465db9": {
      id: "sei_0xf9bdbf259ece5ae17e29bf92eb7abd7b8b465db9",
      attributes: {
        address: "0xf9bdbf259ece5ae17e29bf92eb7abd7b8b465db9",
        name: "Froggy",
        symbol: "FROG",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xF9BDbF259eCe5ae17e29BF92EB7ABd7B8b465Db9.png",
      },
    },
    "0xcf40acbed3f6307c33bf00680c9edae8f7d789ff": {
      id: "sei_0xcf40acbed3f6307c33bf00680c9edae8f7d789ff",
      attributes: {
        address: "0xcf40acbed3f6307c33bf00680c9edae8f7d789ff",
        name: "POCHITA",
        symbol: "POCHITA",
        decimals: 18,
        initialSupply: "10000000000000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xCF40ACBed3f6307C33bF00680c9eDaE8F7d789fF.png",
      },
    },
    "0x9d9b12c69555669966d36596c56061b6cc0a937d": {
      id: "sei_0x9d9b12c69555669966d36596c56061b6cc0a937d",
      attributes: {
        address: "0x9d9b12c69555669966d36596c56061b6cc0a937d",
        name: "xSEIYAN",
        symbol: "xSEIYAN",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x9D9b12c69555669966D36596C56061B6Cc0A937D.png",
      },
    },
    "0x57fba850efca7c72c270a252383767d741c3017f": {
      id: "sei_0x57fba850efca7c72c270a252383767d741c3017f",
      attributes: {
        address: "0x57fba850efca7c72c270a252383767d741c3017f",
        name: "KOSEI",
        symbol: "KOSEI",
        decimals: 6,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x57fBA850EfcA7c72c270A252383767D741C3017F.png",
      },
    },
    "0x00bc9af972b5fb3b7fa04827bd3c17d4599bad8b": {
      id: "sei_0x00bc9af972b5fb3b7fa04827bd3c17d4599bad8b",
      attributes: {
        address: "0x00bc9af972b5fb3b7fa04827bd3c17d4599bad8b",
        name: "WAIT",
        symbol: "WAIT",
        decimals: 6,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x00bc9aF972B5fb3b7fA04827bD3C17d4599BAd8b.png",
      },
    },
    "0x0555e30da8f98308edb960aa94c0db47230d2b9c": {
      id: "sei_0x0555e30da8f98308edb960aa94c0db47230d2b9c",
      attributes: {
        address: "0x0555e30da8f98308edb960aa94c0db47230d2b9c",
        name: "Wrapped BTC",
        symbol: "WBTC",
        decimals: 8,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x0555E30da8f98308EdB960aa94C0Db47230d2B9c.png",
      },
    },
    "0x83c82f0f959ad3eff528ee513b43808aa53f4b37": {
      id: "sei_0x83c82f0f959ad3eff528ee513b43808aa53f4b37",
      attributes: {
        address: "0x83c82f0f959ad3eff528ee513b43808aa53f4b37",
        name: "Rock",
        symbol: "ROCK",
        decimals: 6,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x83c82f0f959aD3eff528eE513b43808Aa53f4B37.png",
      },
    },
    "0x09d9420332bff75522a45fcff4855f82a0a3ff50": {
      id: "sei_0x09d9420332bff75522a45fcff4855f82a0a3ff50",
      attributes: {
        address: "0x09d9420332bff75522a45fcff4855f82a0a3ff50",
        name: "Dinero",
        symbol: "DINERO",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x09d9420332bff75522a45fcff4855f82a0a3ff50.png",
      },
    },
    "0x059a6b0ba116c63191182a0956cf697d0d2213ec": {
      id: "sei_0x059a6b0ba116c63191182a0956cf697d0d2213ec",
      attributes: {
        address: "0x059a6b0ba116c63191182a0956cf697d0d2213ec",
        name: "Synnax Stablecoin",
        symbol: "syUSD",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x059A6b0bA116c63191182a0956cF697d0d2213eC.png",
      },
    },
    "0xea3910f1c6e687b59835885904a2fd1944b51ec6": {
      id: "sei_0xea3910f1c6e687b59835885904a2fd1944b51ec6",
      attributes: {
        address: "0xea3910f1c6e687b59835885904a2fd1944b51ec6",
        name: "OFFICIAL TRUMP",
        symbol: "TRUMP",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xea3910f1C6E687B59835885904A2FD1944B51Ec6.png",
      },
    },
    "0xdf77686d99667ae56bc18f539b777dbc2bbe3e9f": {
      id: "sei_0xdf77686d99667ae56bc18f539b777dbc2bbe3e9f",
      attributes: {
        address: "0xdf77686d99667ae56bc18f539b777dbc2bbe3e9f",
        name: "Staked fastUSD",
        symbol: "sfastUSD",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xdf77686D99667Ae56BC18f539B777DBc2BBE3E9F.png",
      },
    },
    "0x5bff88ca1442c2496f7e475e9e7786383bc070c0": {
      id: "sei_0x5bff88ca1442c2496f7e475e9e7786383bc070c0",
      attributes: {
        address: "0x5bff88ca1442c2496f7e475e9e7786383bc070c0",
        name: "Staked Frax USD",
        symbol: "sfrxUSD",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x5Bff88cA1442c2496f7E475E9e7786383Bc070c0.png",
      },
    },
    "0x6ab5d5e96ac59f66bab57450275cc16961219796": {
      id: "sei_0x6ab5d5e96ac59f66bab57450275cc16961219796",
      attributes: {
        address: "0x6ab5d5e96ac59f66bab57450275cc16961219796",
        name: "sUSDa",
        symbol: "sUSDa",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x6ab5d5e96ac59f66bab57450275cc16961219796.png",
      },
    },
    "0xff12470a969dd362eb6595ffb44c82c959fe9acc": {
      id: "sei_0xff12470a969dd362eb6595ffb44c82c959fe9acc",
      attributes: {
        address: "0xff12470a969dd362eb6595ffb44c82c959fe9acc",
        name: "USDa",
        symbol: "USDa",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xff12470a969Dd362EB6595FFB44C82c959Fe9ACc.png",
      },
    },
    "0xbe574b6219c6d985d08712e90c21a88fd55f1ae8": {
      id: "sei_0xbe574b6219c6d985d08712e90c21a88fd55f1ae8",
      attributes: {
        address: "0xbe574b6219c6d985d08712e90c21a88fd55f1ae8",
        name: "WSTETH",
        symbol: "WSTETH",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xBE574b6219C6D985d08712e90C21A88fd55f1ae8.png",
      },
    },
    "0x9151434b16b9763660705744891fa906f660ecc5": {
      id: "sei_0x9151434b16b9763660705744891fa906f660ecc5",
      attributes: {
        address: "0x9151434b16b9763660705744891fa906f660ecc5",
        name: "USDT0",
        symbol: "USDT",
        decimals: 6,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x9151434b16b9763660705744891fa906f660ecc5.png",
      },
    },
    "0x541fd749419ca806a8bc7da8ac23d346f2df8b77": {
      id: "sei_0x541fd749419ca806a8bc7da8ac23d346f2df8b77",
      attributes: {
        address: "0x541fd749419ca806a8bc7da8ac23d346f2df8b77",
        name: "Solv BTC",
        symbol: "SolvBTC",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x541FD749419CA806a8bc7da8ac23D346f2dF8B77.png",
      },
    },
    "0xcc0966d8418d412c599a6421b760a847eb169a8c": {
      id: "sei_0xcc0966d8418d412c599a6421b760a847eb169a8c",
      attributes: {
        address: "0xcc0966d8418d412c599a6421b760a847eb169a8c",
        name: "xSolvBTC",
        symbol: "xSolvBTC",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xCC0966D8418d412c599A6421b760a847eB169A8c.png",
      },
    },
    "0x78e26e8b953c7c78a58d69d8b9a91745c2bbb258": {
      id: "sei_0x78e26e8b953c7c78a58d69d8b9a91745c2bbb258",
      attributes: {
        address: "0x78e26e8b953c7c78a58d69d8b9a91745c2bbb258",
        name: "uBTC",
        symbol: "uBTC",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x78E26E8b953C7c78A58d69d8B9A91745C2BbB258.png",
      },
    },
    "0x8d4bd7f15ab970bf9ade5b15116cd663bf8c861e": {
      id: "sei_0x8d4bd7f15ab970bf9ade5b15116cd663bf8c861e",
      attributes: {
        address: "0x8d4bd7f15ab970bf9ade5b15116cd663bf8c861e",
        name: "Jelly (Meme)",
        symbol: "JELLY",
        decimals: 6,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x8d4bd7f15ab970bf9ade5b15116cd663bf8c861e.png",
      },
    },
    "0xd049e189acc1873bca8c0a314d6b26835684fb89": {
      id: "sei_0xd049e189acc1873bca8c0a314d6b26835684fb89",
      attributes: {
        address: "0xd049e189acc1873bca8c0a314d6b26835684fb89",
        name: "Red",
        symbol: "RED",
        decimals: 6,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xd049e189acc1873bca8c0a314d6b26835684fb89.png",
      },
    },
    "0x4605232ea642a328bdc036f2eba9b8c4c59b6cf8": {
      id: "sei_0x4605232ea642a328bdc036f2eba9b8c4c59b6cf8",
      attributes: {
        address: "0x4605232ea642a328bdc036f2eba9b8c4c59b6cf8",
        name: "BULLX",
        symbol: "BULLX",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x4605232ea642a328bdc036f2eba9b8c4c59b6cf8.png",
      },
    },
    "0xe15fc38f6d8c56af07bbcbe3baf5708a2bf42392": {
      id: "sei_0xe15fc38f6d8c56af07bbcbe3baf5708a2bf42392",
      attributes: {
        address: "0xe15fc38f6d8c56af07bbcbe3baf5708a2bf42392",
        name: "USDC",
        symbol: "USDC",
        decimals: 6,
        initialSupply: "10000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xe15fc38f6d8c56af07bbcbe3baf5708a2bf42392.png",
      },
    },
    "0x0a526e425809aea71eb279d24ae22dee6c92a4fe": {
      id: "0x0a526e425809aea71eb279d24ae22dee6c92a4fe",
      attributes: {
        address: "0x0a526e425809aea71eb279d24ae22dee6c92a4fe",
        name: "Dragonswap Token",
        symbol: "DRG",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x0a526e425809aEA71eb279d24ae22Dee6C92A4Fe.png",
      },
    },
    "0x049eaa1b2c9934aaacc12a141484eefd62867653": {
      id: "sei_0x049eaa1b2c9934aaacc12a141484eefd62867653",
      attributes: {
        address: "0x049eaa1b2c9934aaacc12a141484eefd62867653",
        name: "aUSD",
        symbol: "aUSD",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x049eaa1b2c9934aaacc12a141484eefd62867653.png",
      },
    },
    "0x7d330358f0be21feeb751d0622ffee04e25d7dfa": {
      id: "sei_0x7d330358f0be21feeb751d0622ffee04e25d7dfa",
      attributes: {
        address: "0x7d330358f0be21feeb751d0622ffee04e25d7dfa",
        name: "aMSTR",
        symbol: "aMSTR",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x7d330358f0be21feeb751d0622ffee04e25d7dfa.png",
      },
    },
    "0x5b8203e65aa5be3f1cf53fd7fa21b91ba4038ecc": {
      id: "sei_0x5b8203e65aa5be3f1cf53fd7fa21b91ba4038ecc",
      attributes: {
        address: "0x5b8203e65aa5be3f1cf53fd7fa21b91ba4038ecc",
        name: "APO",
        symbol: "APO",
        decimals: 18,
        initialSupply: "1000000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0x5b8203e65aa5be3f1cf53fd7fa21b91ba4038ecc.png",
      },
    },
    "0xc257361320f4514d91c05f461006ce6a0300e2d2": {
      id: "sei_0xc257361320f4514d91c05f461006ce6a0300e2d2",
      attributes: {
        address: "0xc257361320f4514d91c05f461006ce6a0300e2d2",
        name: "Splashing SEI",
        symbol: "spSEI",
        decimals: 18,
        initialSupply: "10000000000000000000",
        logoUrl:
          "https://raw.githubusercontent.com/Symphony-Exchange/Symphony-Exchange-Assetlist/refs/heads/main/logos/0xc257361320f4514d91c05f461006ce6a0300e2d2.png",
      },
    },
  },
};
